module.exports = __webpack_public_path__ + "media/components/shared/static/arrow_next-dark-25e4f19cc886a0d5a1737ab714c2dbbf.svg";